import { connect } from 'react-redux';
import { getNotes } from '../selectors';
import { getSummaryFieldValues, getOptionThumbnails } from '../selectors/hybrid';
import FlooringSummary from '../components/FlooringSummary';

const mapStateToProps = (state, ownProps) => {
  const configuratorState = state.ConfiguratorStore;
  return {
    summaryValues: getSummaryFieldValues(configuratorState),
    thumbnails: getOptionThumbnails(configuratorState),
    notes: getNotes(configuratorState)
  };
};

const FlooringSummaryContainer = connect(
  mapStateToProps
)(FlooringSummary);

export default FlooringSummaryContainer;
